import { Link } from 'react-router-dom';

const articles = [
  {
    path: '/guida-itaobuy-spreadsheet-italiano',
    title: 'Guida Completa Itaobuy Spreadsheet Italiano',
    desc: 'Tutto quello che devi sapere su itaobuy spreadsheet: come funziona, come trovare i prodotti migliori, guida alle taglie e consigli per risparmiare.',
    icon: 'ri-book-open-line',
    color: 'primary',
    img: 'https://readdy.ai/api/search-image?query=A%20clean%20minimalist%20desk%20setup%20with%20a%20laptop%20displaying%20a%20spreadsheet%2C%20notebook%2C%20and%20coffee%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20photography&width=400&height=260&seq=art-img-guida&orientation=landscape',
  },
  {
    path: '/itaobuy-e-sicuro',
    title: 'Itaobuy è Sicuro? Analisi 2026',
    desc: 'Analisi completa sulla sicurezza: protezione dati, pagamenti sicuri, recensioni verificate e consigli per acquistare senza rischi.',
    icon: 'ri-shield-check-line',
    color: 'accent',
    img: 'https://readdy.ai/api/search-image?query=A%20padlock%20icon%20on%20a%20clean%20warm%20background%20with%20soft%20shadows%2C%20representing%20online%20security%20and%20safe%20shopping%2C%20minimalist%20conceptual%20photography&width=400&height=260&seq=art-img-sicuro&orientation=landscape',
  },
  {
    path: '/come-usare-itaobuy-spreadsheet',
    title: 'Come Usare Itaobuy Spreadsheet',
    desc: 'Guida passo passo per principianti: impara a navigare il database, trovare i prodotti migliori e fare acquisti intelligenti.',
    icon: 'ri-user-star-line',
    color: 'secondary',
    img: 'https://readdy.ai/api/search-image?query=A%20person%20hands%20typing%20on%20a%20laptop%20keyboard%20with%20a%20notebook%20nearby%20on%20a%20warm%20wooden%20desk%2C%20clean%20minimalist%20workspace%2C%20soft%20natural%20lighting&width=400&height=260&seq=art-img-usare&orientation=landscape',
  },
  {
    path: '/itaobuy-spreadsheet-sneakers',
    title: 'Itaobuy Spreadsheet Sneakers',
    desc: 'Le migliori scarpe su itaobuy: modelli esclusivi, edizioni limitate e sneakers di tendenza. Guida alle taglie e consigli di acquisto.',
    icon: 'ri-shopping-bag-3-line',
    color: 'primary',
    img: 'https://readdy.ai/api/search-image?query=A%20stylish%20pair%20of%20designer%20sneakers%20displayed%20on%20a%20minimalist%20white%20pedestal%20against%20a%20warm%20cream%20wall%2C%20editorial%20product%20photography%2C%20soft%20studio%20lighting&width=400&height=260&seq=art-img-sneakers&orientation=landscape',
  },
  {
    path: '/itaobuy-spreadsheet-moda',
    title: 'Moda e Abbigliamento Streetwear',
    desc: 'Il meglio dello streetwear su itaobuy: hoodie, t-shirt, giacche e pantaloni. Scopri le tendenze e i capi più ricercati.',
    icon: 'ri-t-shirt-line',
    color: 'accent',
    img: 'https://readdy.ai/api/search-image?query=A%20carefully%20styled%20flatlay%20of%20contemporary%20streetwear%20clothing%20including%20a%20graphic%20hoodie%2C%20white%20t-shirt%2C%20and%20accessories%20on%20a%20warm%20textured%20surface&width=400&height=260&seq=art-img-moda&orientation=landscape',
  },
  {
    path: '/itaobuy-spedizione-italia',
    title: 'Spedizione in Italia: Guida Completa',
    desc: 'Costi, tempi e consigli per la spedizione itaobuy in Italia. Come risparmiare sulle spese di consegna internazionale.',
    icon: 'ri-truck-line',
    color: 'secondary',
    img: 'https://readdy.ai/api/search-image?query=A%20cardboard%20shipping%20box%20with%20packing%20tape%20on%20a%20clean%20warm%20surface%2C%20minimalist%20product%20photography%2C%20ecommerce%20shipping%20concept%2C%20soft%20lighting&width=400&height=260&seq=art-img-spedizione&orientation=landscape',
  },
  {
    path: '/itaobuy-prezzi',
    title: 'Prezzi e Costi: Guida al Risparmio',
    desc: 'Quanto costa davvero itaobuy? Guida ai prezzi delle varie categorie, strategie per risparmiare e ottimizzare il budget.',
    icon: 'ri-money-euro-circle-line',
    color: 'primary',
    img: 'https://readdy.ai/api/search-image?query=A%20minimalist%20still%20life%20with%20a%20calculator%2C%20coins%2C%20and%20a%20receipt%20on%20a%20warm%20cream%20surface%2C%20clean%20financial%20concept%20photography%2C%20soft%20lighting&width=400&height=260&seq=art-img-prezzi&orientation=landscape',
  },
  {
    path: '/itaobuy-vs-alternative',
    title: 'Itaobuy vs Alternative a Confronto',
    desc: 'Confronto completo tra itaobuy, sugargoo, pandabuy e altri agent. Quale scegliere per i tuoi acquisti?',
    icon: 'ri-scales-3-line',
    color: 'accent',
    img: 'https://readdy.ai/api/search-image?query=A%20split%20comparison%20concept%20with%20two%20contrasting%20product%20boxes%20on%20a%20clean%20warm%20surface%2C%20minimalist%20editorial%20style%2C%20soft%20lighting%2C%20elegant%20composition&width=400&height=260&seq=art-img-vs&orientation=landscape',
  },
  {
    path: '/itaobuy-qc-photos',
    title: 'Come Leggere le QC Photos',
    desc: 'Guida completa al controllo qualità: impara a valutare cuciture, materiali, logo e dettagli dalle foto prima di acquistare.',
    icon: 'ri-search-eye-line',
    color: 'secondary',
    img: 'https://readdy.ai/api/search-image?query=A%20magnifying%20glass%20over%20a%20product%20tag%20on%20a%20warm%20cream%20surface%2C%20quality%20inspection%20concept%2C%20clean%20minimalist%20photography%2C%20soft%20studio%20lighting&width=400&height=260&seq=art-img-qc&orientation=landscape',
  },
  {
    path: '/itaobuy-recensioni',
    title: 'Recensioni e Opinioni Italiane',
    desc: 'Cosa dicono gli utenti italiani di itaobuy? Leggi esperienze reali, opinioni e consigli dalla community attiva.',
    icon: 'ri-chat-quote-line',
    color: 'primary',
    img: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20handwritten%20review%20notes%20and%20star%20ratings%20on%20a%20warm%20cream%20surface%2C%20customer%20feedback%20concept%2C%20clean%20minimalist%20photography&width=400&height=260&seq=art-img-recensioni&orientation=landscape',
  },
  {
    path: '/faq-itaobuy',
    title: 'FAQ: Domande Frequenti',
    desc: 'Risposte alle domande più comuni su itaobuy spreadsheet: funzionamento, sicurezza, costi, spedizione e molto altro.',
    icon: 'ri-question-answer-line',
    color: 'accent',
    img: 'https://readdy.ai/api/search-image?query=A%20minimalist%20arrangement%20of%20question%20mark%20shaped%20paper%20notes%20on%20a%20warm%20cream%20surface%2C%20FAQ%20concept%2C%20clean%20editorial%20photography%2C%20soft%20lighting&width=400&height=260&seq=art-img-faq&orientation=landscape',
  },
];

function getColorClasses(color: string) {
  const map: Record<string, { iconBg: string; iconText: string; hoverBorder: string }> = {
    primary: { iconBg: 'bg-primary-100', iconText: 'text-primary-600', hoverBorder: 'hover:border-primary-200' },
    accent: { iconBg: 'bg-accent-100', iconText: 'text-accent-600', hoverBorder: 'hover:border-accent-200' },
    secondary: { iconBg: 'bg-secondary-100', iconText: 'text-secondary-600', hoverBorder: 'hover:border-secondary-200' },
  };
  return map[color] || map.primary;
}

export default function FeaturedArticles() {
  return (
    <section className="bg-background-100 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block font-label text-xs uppercase tracking-[0.25em] text-secondary-600 bg-secondary-100/70 px-4 py-1.5 rounded-full mb-4">
            Articoli SEO
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            Guide &amp; Risorse Itaobuy
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Approfondisci con le nostre guide complete e ottimizzate per aiutarti a fare acquisti migliori
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article) => {
            const colors = getColorClasses(article.color);
            return (
              <Link
                key={article.path}
                to={article.path}
                className={`group bg-background-50 rounded-2xl overflow-hidden cursor-pointer border border-background-200/70 ${colors.hoverBorder} transition-all flex flex-col`}
              >
                <div className="w-full h-44 overflow-hidden">
                  <img
                    src={article.img}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className={`w-10 h-10 rounded-xl ${colors.iconBg} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                    <i className={`${article.icon} text-lg ${colors.iconText}`}></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed mb-4 flex-1">
                    {article.desc}
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-600 group-hover:gap-2.5 transition-all mt-auto">
                    Leggi articolo
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}